function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.854 8.146a.5.5 0 00-.708.708L22.293 11H17.5a2.5 2.5 0 00-2.5 2.5v6a1.5 1.5 0 01-1.5 1.5h-.55a2.5 2.5 0 100 1h.55a2.5 2.5 0 002.5-2.5v-6a1.5 1.5 0 011.5-1.5h4.793l-2.147 2.146a.5.5 0 00.708.708l3-3a.5.5 0 000-.708l-3-3zM12 21.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
  fill: "#6264A7"
});

function SvgRelateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRelateIcon;